const single_sign_on = {
    forbidden_domains: 'Los dominios de correo electrónico público no están permitidos.',
    duplicated_domains: 'Hay dominios duplicados.',
    invalid_domain_format: 'Formato de dominio no válido.',
    duplicate_connector_name: 'El nombre del conector ya existe. Por favor elige un nombre diferente.',
};
export default Object.freeze(single_sign_on);
